<template>
  <el-submenu index="2" class="menu-item-lang" popper-class="menu-item-lang-options" :popper-append-to-body="true">
    <template slot="title">
      <span>{{ locale }}</span>
      <svgicon :name="locale" class="menu-item-lang-item" :original="true"></svgicon>
    </template>
    <el-menu-item v-for="lang in langList" :item="lang" :key="lang.id" :index="lang" @click="changeLocale(lang)" :route="{ path: $route.fullPath }">
      <span>{{ lang }}</span>
      <svgicon :name="lang" class="menu-item-lang-item" :original="true"></svgicon>
    </el-menu-item>
  </el-submenu>
</template>

<script>
import i18n from '@/lang/index'
import Cookies from 'js-cookie'

export default {
  name: 'iDalgo-Lang-Selection',
  data () {
    return {}
  },
  computed: {
    locale () {
      return i18n.locale.toUpperCase()
    },
    // retrieve all langs except the locale
    langList () {
      return Object.keys(i18n.messages)
        .filter((item) => (item !== i18n.locale))
        .map((item) => (item.toUpperCase()))
    }
  },
  methods: {
    changeLocale (locale) {
      i18n.locale = locale.toLowerCase()
      Cookies.set('locale', locale.toLowerCase(), { expires: 20000, domain: process.env.DOMAIN })
    }
  }
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/iDalgo-Nav-Menus/iDalgo-Lang-Selection.vue